import React, { Component } from "react";
import uuid from "react-uuid";
import { toast } from "react-toastify";
import { getOrganizations } from "../../../common/services/auth/organizationService";
import {
  getMarketControlByMarket,
  insertOrUpdateMarketControl,
} from "../../../common/services/tradingEngine/marketStateService";
import Loading from "../../../common/components/loading/loading";
import DualListBox from "../../../common/components/form/dualListBox";
import { withTranslation } from "react-i18next";

class TradingMarketOrganizations extends Component {
  state = {
    options: [],
    selected: [],
    marketControl: null,
    isLoading: true,
  };

  async componentDidMount() {
    await this.loadData();
  }

  async componentDidUpdate(previousProps) {
    if (previousProps.marketId !== this.props.marketId) {
      await this.loadData();
    }
  }

  async loadData() {
    const { marketId } = this.props;
    const [organizations, marketControl] = await Promise.all([
      getOrganizations(),
      getMarketControlByMarket(marketId),
    ]);

    const selected = marketControl.organizationIds || [];
    this.setState({
      options: this.mapToOptionsViewModel(organizations, selected),
      selected,
      marketControl,
      isLoading: false,
    });
  }

  mapToOptionsViewModel(organizations, selectedOrganizationIds) {
    return organizations
      .filter(
        (organization) =>
          organization.active ||
          selectedOrganizationIds.includes(organization.organizationId)
      )
      .map((organization) => ({
        value: organization.organizationId,
        label:
          organization.shortName && organization.shortName !== organization.name
            ? `${organization.name} (${organization.shortName})`
            : organization.name || organization.organizationId,
      }))
      .sort((left, right) => left.label.localeCompare(right.label));
  }

  async handleChange(selected, selection, controlKey) {
    const { t, marketName } = this.props;
    const previousSelected = [...this.state.selected];

    if (controlKey !== "available" && controlKey !== "selected") {
      toast.warning(t("UnexpectedError"));
      return null;
    }

    this.setState({ selected });

    try {
      const updatedMarketControl = await insertOrUpdateMarketControl({
        ...this.state.marketControl,
        organizationIds: selected,
        eventId: uuid(),
      });

      this.setState({
        selected: updatedMarketControl.organizationIds || [],
        marketControl: updatedMarketControl,
      });

      this.props.onUpdated?.({
        ...updatedMarketControl,
        name: marketName,
      });
      toast.success(t("TradingMarketOrganizationsUpdated"));
    } catch (ex) {
      console.log(ex);
      this.setState({ selected: previousSelected });
      toast.error(t("TradingMarketOrganizationsUpdateFailed"));
    }
  }

  render() {
    const { options, selected, isLoading } = this.state;
    const { allowEdit, t } = this.props;

    if (isLoading) return <Loading />;

    return (
      <div>
        <DualListBox
          canFilter
          className="rdl-hide-move-all"
          disabled={!allowEdit}
          options={options}
          selected={selected}
          onChange={(nextSelected, selection, controlKey) =>
            this.handleChange(nextSelected, selection, controlKey)
          }
        />
        <small className="form-text text-muted">
          {t("TradingMarketOrganizationsHelpText")}
        </small>
      </div>
    );
  }
}

export default withTranslation(["trading"])(TradingMarketOrganizations);
